import { Link } from "react-router-dom";
import { resetAnalytics } from "@/lib/analytics";

export function Privacy() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-5 pt-8 pb-12">
      <article className="w-full max-w-[680px] bg-white px-8 pt-9 pb-10 relative animate-ink-in">
        <Link
          viewTransition
          to="/"
          className="text-[0.95rem] text-[rgba(31,29,25,0.72)] hover:text-[rgba(31,29,25,1)] underline underline-offset-4 decoration-1 mb-6 inline-block"
        >
          ← Back
        </Link>

        <h1 className="text-[1.4rem] font-normal mb-6">Datenschutzerklärung</h1>

        <section className="text-[0.95rem] space-y-6">
          <div>
            <h2 className="text-[1.02rem] mb-2">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              Allgemeine Hinweise
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Die folgenden Hinweise geben einen einfachen Überblick darüber,
              was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
              Website besuchen.
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">
              2. Datenerfassung auf dieser Website
            </h2>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              Verantwortliche Stelle
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Karim Siala<br />
              E-Mail: karim@roboticscollective.org
            </p>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              E-Mail Newsletter
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Wenn Sie sich für unseren Newsletter anmelden, verwenden wir die
              von Ihnen angegebene E-Mail-Adresse ausschließlich für den Versand
              von Updates und Informationen. Die Datenverarbeitung erfolgt auf
              Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie
              können Ihre Einwilligung jederzeit widerrufen.
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">
              3. Hosting und Formularverarbeitung
            </h2>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">Netlify</h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Diese Website wird auf Servern von Netlify gehostet. Netlify
              verarbeitet die über das E-Mail-Formular erhobenen Daten. Weitere
              Informationen finden Sie in der Datenschutzerklärung von Netlify:{" "}
              <a
                href="https://www.netlify.com/privacy/"
                className="underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.netlify.com/privacy/
              </a>
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">4. Analyse-Tools</h2>

            <h3 className="text-[0.95rem] font-normal mt-3 mb-1">
              Google Analytics
            </h3>
            <p className="text-[rgba(31,29,25,0.72)]">
              Diese Website lädt Google Analytics erst, wenn Sie der Analyse
              zustimmen. Erfasst werden Seitenaufrufe, sichtbare Projektkarten,
              Projektklicks, Filterauswahl, aktive Lesezeit und Klicks auf
              Kontaktlinks. Die durch das Cookie erzeugten Informationen über
              Ihre Benutzung dieser Website werden in der Regel an einen Server
              von Google in den USA übertragen und dort gespeichert. Die
              Analyse dient dazu, das Interesse an den vorgestellten Projekten
              zu verstehen. Ihre Auswahl wird lokal in Ihrem Browser gespeichert.
              Sie können Ihre Auswahl jederzeit zurücksetzen.
            </p>
            <button type="button" onClick={resetAnalytics} className="underline underline-offset-4">Analytics-Auswahl zurücksetzen / Reset analytics preference</button>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">5. Ihre Rechte</h2>
            <p className="text-[rgba(31,29,25,0.72)]">
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
              Einschränkung der Verarbeitung, Datenübertragbarkeit und
              Widerspruch bezüglich Ihrer personenbezogenen Daten. Wenden Sie
              sich hierzu an: karim@roboticscollective.org
            </p>
          </div>

          <div>
            <h2 className="text-[1.02rem] mb-2">6. Datenspeicherung</h2>
            <p className="text-[rgba(31,29,25,0.72)]">
              E-Mail-Adressen aus dem Newsletter-Formular werden gespeichert,
              bis Sie Ihre Einwilligung widerrufen oder die Löschung
              beantragen.
            </p>
          </div>

          <div className="text-[0.88rem] text-[rgba(31,29,25,0.62)] mt-6">
            <p>Stand: September 2026</p>
          </div>
        </section>
      </article>

      <footer className="mt-7 text-[0.70rem] tracking-[0.1em] text-[rgba(31,29,25,0.62)]">
        © {new Date().getFullYear()}
      </footer>
    </main>
  );
}
